const endpoints = {
	getVTReportTemplates: '/schedule/getVTReportTemplates',
	createVTReportTemplate: '/schedule/createVTReportTemplate',
	updateVTReportTemplate: '/schedule/updateVTReportTemplate',
	deleteVTReportTemplate: '/schedule/deleteVTReportTemplate',
	getStates: '/general/getStates',
	getCities: '/general/getCities',
	getCountryCities: '/general/getCountryCities',
	getPolicyAcceptance: '/general/getPolicyAcceptance',
	getPolicyUserAcceptance: '/general/getPolicyUserAcceptance',
	getCoordinatesValuesPolygon: '/schedule/getCoordinatesValuesPolygon',
	updateAddress: '/general/updateAddress',
	getUfValues: '/general/getUfValues',
	getTaxesOptions: '/general/getTaxesOptions',
	getCompanyTaxesOptions: '/general/getCompanyTaxesOptions',
	setTaxOption: '/general/setTaxOption',
	deleteTaxOption: '/general/deleteTaxOption',
	updatePublicProfile: '/socials/updatePublicProfile',
	updatePublicProfileStatus: '/socials/updatePublicProfileStatus',
	getItemPublicProfile: '/socials/getItemPublicProfile',
	getUserProjectLines: '/user_request/getUserProjectLines',

	//Payments
	createPaymentOrder: '/payments/createPaymentOrder',
	startOrderPayment: '/payments/startOrderPayment',
	createManualPayment: '/payments/createManualPayment',
	sendPaymentRequest: '/payments/sendPaymentRequest',
	sendSupervisionPaymentRequest: '/payments/sendSupervisionPaymentRequest',
}
export {endpoints}